import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import DrawerConfig from "../modules/main/Navigation/drawer-config";
import Utils from "../utils";

interface Breadcrumb {
  name?: string;
  slug: string;
}

export default function useBreadcrumbs(): Breadcrumb[] {
  const location = useLocation();

  const [breadcrumbs, setBreadcrumbs] = React.useState<Breadcrumb[]>([]);

  const drawerItemsMapping = useMemo(() => {
    const drawerItems = [...DrawerConfig.Common];
    return Utils.flattenDrawerList(drawerItems);
  }, []);

  React.useEffect(() => {
    const paths = location.pathname
      .split("/")
      .filter((item) => item.length > 0);

    // Normalize paths to match keys in drawerItemsMapping
    setBreadcrumbs(
      paths.map((path) => ({
        name: drawerItemsMapping[path], // Use normalized path
        slug: path,
      }))
    );
  }, [location, drawerItemsMapping]);

  return breadcrumbs;
}
